var TEXT_PROPTYPES = {
  color_text_list: ["green", "red", "azure", "default", "grey-1", "grey-2"],
  font_family_list: ["euclid", "stolzl", "roboto", "graphik"],
  font_size_list: ["xxlarge", "xxlargeM", "xlarge", "xlargeM", "large", "largeM", "largeB", "medium", "mediumM", "small", "smallM", "xsmall"],
  type_list: ["display", "heading", "label", "paragraph"],
  is_mobile_list: ["true", "false"]
};
var BUTTON_PROPTYPES = {
  colors_list: ["green", "red", "azure", "baseColor", "white", "grayFour", "grayEight", "grayNine"],
  types_list: ["primary", "secondary", "outlined", "text"],
  text_types_list: ["small", "medium", "large"],
  active_list: ["true", "false"],
  border_radius_types_list: ["rounded", "smallRounded"],
  no_borders_list: ["true", "false"],
  heights_list: ["xsmall", "small", "medium", "large", "xlarge"]
};
export { BUTTON_PROPTYPES, TEXT_PROPTYPES };